import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { onboardingService } from '@/features/onboarding/services/onboardingService';
import { OnboardingWizard } from '@/features/onboarding/components/OnboardingWizard';
import styles from '@/features/onboarding/components/Onboarding.module.css';
import { LOGIN } from '@/shared/constants/routes';
import { Button } from '@chikara/ui';
import { t } from '@/i18n';

export function OnboardingInvitePage() {
	const [searchParams] = useSearchParams();
	const token = searchParams.get('reference') ?? '';
	const [isValidating, setIsValidating] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [passwordToken, setPasswordToken] = useState<string | null>(null);
	const [user, setUser] = useState<any>(null);


	useEffect(() => {
		const validateToken = async () => {
			if (!token) {
				setError(t('onboarding.error.invalidToken'));
				setIsValidating(false);
				return;
			}

			try {
				const response = await onboardingService.acceptInvite(token);
				if (response?.data.password_token) {
					setPasswordToken(response.data.password_token);
				}
				if (response?.data) {
					setUser(response.data);
				}
				setError(null);
			} catch (err: any) {
				setError(t('onboarding.error.subtitle'));
			} finally {
				setIsValidating(false);
			}
		};

		validateToken();
	}, [token]);

	if (isValidating) {
		return (
			<div className={styles.loadingContainer}>
				<div className={styles.spinner} />
				<p>{t('onboarding.error.validating')}</p>
			</div>
		);
	}

	if (error || !token) {
		return (
			<div className={styles.errorContainer}>
				<h2 className={styles.errorTitle}>{t('onboarding.error.title')}</h2>
				<p className={styles.errorMessage}>{error}</p>
				<Button onClick={() => window.location.href = LOGIN} className={styles.submitButton}>
					{t('onboarding.error.action')}
				</Button>
			</div>
		);
	}

	return (
		<div className={styles.pageContainer}>
			<OnboardingWizard token={passwordToken ?? token} user={user}/>
		</div>
	);
}
